import EfSpec from '@elem/ui/ef-spec';
import { useEffect } from 'react';
import EfImg from '@elem/ui/ef-img';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('Oasis.Charts');
    const { locale = 'us' } = useRouter();
    // 动画
    const { isH5, isPad } = useMediaDevice();
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const box = document.querySelector('#Charts') as HTMLDivElement;
            if (isH5) {
                box.style.opacity = '1';
                return;
            }
            if (box) {
                const winH = window.innerHeight;
                const scene1 = AniContainer.create({
                    triggerElement: '#Charts', // 触发元素
                    triggerHook: 1, // 触发时机 1 进入 0 离开
                    duration: box?.offsetHeight + winH,
                    offset: 0,
                    asyncFromTo: [
                        [box, { opacity: 0 }, { opacity: 1 }, 0.2],
                        [box, { opacity: 1 }, { opacity: 0 }, 0.2],
                        [box, { opacity: 0 }, { opacity: 0 }, 0.1],
                    ],
                    asyncTimeLine: [0.1, 0.7, 0.9],
                });

                return () => {
                    scene1.destroy();
                };
            }
        }
    }, [isPad, isH5]);
    const imgItems: {
        [key: string]: any;
    } = {
        us: [
            ['https://websiteoss.ecoflow.com/upload/image/1736234852404/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1736234959557/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735023713029/Charts2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735023712856/Charts2-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735023713370/Charts3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735023713206/Charts3-h5.jpg',
            ],
        ],
        ca: [
            ['https://websiteoss.ecoflow.com/upload/image/1736234852404/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1736234959557/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735023713029/Charts2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735023712856/Charts2-h5.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1735023713370/Charts3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1735023713206/Charts3-h5.jpg',
            ],
        ],
        eu: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859042/Frame%201612689904.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931961/Frame%201612690136.png',
            ],
            ['https://websiteoss.ecoflow.com/upload/image/1744686019827/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744686019681/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859219/Group%201321320598.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931796/Frame%201612690135.png',
            ],
        ],
        nl: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859042/Frame%201612689904.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931961/Frame%201612690136.png',
            ],
            ['https://websiteoss.ecoflow.com/upload/image/1744686019827/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744686019681/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859219/Group%201321320598.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931796/Frame%201612690135.png',
            ],
        ],
        uk: [
            ['https://websiteoss.ecoflow.com/upload/image/1744618093969/uk-pc.png', 'https://websiteoss.ecoflow.com/upload/image/1744618093621/uk-m.png'],
            ['https://websiteoss.ecoflow.com/upload/image/1744686019827/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744686019681/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458981919/Group%201321320598.png',
                'https://websiteoss.ecoflow.com/upload/image/1744459014287/Frame%201612690135.png',
            ],
        ],
        de: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744360143746/Frame%201612689904.png',
                'https://websiteoss.ecoflow.com/upload/image/1744360199949/Frame%201612689982.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744360143276/Frame%201612689835.png',
                'https://websiteoss.ecoflow.com/upload/image/1744360200115/Frame%201612689984.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744360143444/Frame%201612689918.png',
                'https://websiteoss.ecoflow.com/upload/image/1744360200330/Frame%201612690004.png',
            ],
        ],
        fr: [
            ['https://websiteoss.ecoflow.com/upload/image/1744686196840/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744686196668/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744364398421/Frame%201612689835.png',
                'https://websiteoss.ecoflow.com/upload/image/1744364513648/Frame%201612690122.png',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744364398742/Frame%201612690119.png',
                'https://websiteoss.ecoflow.com/upload/image/1744364513456/Frame%201612690120.png',
            ],
        ],
        it: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859042/Frame%201612689904.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931961/Frame%201612690136.png',
            ],
            ['https://websiteoss.ecoflow.com/upload/image/1744686019827/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744686019681/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859219/Group%201321320598.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931796/Frame%201612690135.png',
            ],
        ],
        es: [
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859042/Frame%201612689904.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931961/Frame%201612690136.png',
            ],
            ['https://websiteoss.ecoflow.com/upload/image/1744686019827/PC.png', 'https://websiteoss.ecoflow.com/upload/image/1744686019681/M.png'],
            [
                'https://websiteoss.ecoflow.com/upload/image/1744458859219/Group%201321320598.png',
                'https://websiteoss.ecoflow.com/upload/image/1744458931796/Frame%201612690135.png',
            ],
        ],
    };
    return (
        <div className={`Charts ${styles.TheComp}`} id="Charts">
            <EfSpec />
            <div className="container">
                <div className="item">
                    <div className="desc">
                        {t.rich('card1Title', {
                            h: (v: string) => <span className="highlight">{v}</span>,
                        })}
                    </div>
                    <EfImg pc={imgItems[locale][0][0]} pad={imgItems[locale][0][0]} h5={imgItems[locale][0][1]} />
                </div>
                <div className="item">
                    <div className="desc">
                        {t.rich('card2Title', {
                            h: (v: string) => <span className="highlight">{v}</span>,
                        })}
                    </div>
                    <EfImg pc={imgItems[locale][1][0]} pad={imgItems[locale][1][0]} h5={imgItems[locale][1][1]} />
                </div>
                <div className="item">
                    <div className="desc">
                        {t.rich('card3Title', {
                            h: (v: string) => <span className="highlight">{v}</span>,
                        })}
                    </div>
                    <EfImg pc={imgItems[locale][2][0]} pad={imgItems[locale][2][0]} h5={imgItems[locale][2][1]} />
                </div>
            </div>
            <EfSpec />
        </div>
    );
}
